import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import AmendHpDeviceProvider from "./baseProviders/amendHpDeviceProvider"
import useStartNewHpDeviceAmendment from "../../../../../services/middleware/hooks/devices/lct/useStartNewHpDeviceAmendment"

interface INewHpDeviceAmendmentFormUrlParams {
    deviceRef: string
}

interface INewHpDeviceAmendmentProviderProps {
    children: ReactNode
}

const NewHpDeviceAmendmentProvider = ({
    children,
}: INewHpDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewHpDeviceAmendmentFormUrlParams
    >() as INewHpDeviceAmendmentFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data,
        setData,
        isLoading,
        error: newHpDeviceAmendmentError,
    } = useStartNewHpDeviceAmendment(urlDeviceRef, attachmentUUID)

    return (
        <AmendHpDeviceProvider
            formData={data}
            setFormData={setData}
            formDataIsLoading={isLoading}
            formDataError={newHpDeviceAmendmentError}
            attachmentUUID={attachmentUUID}
            systemReference={urlDeviceRef}
        >
            {children}
        </AmendHpDeviceProvider>
    )
}

export default NewHpDeviceAmendmentProvider
